export default __webpack_public_path__ + "static/ak-cached/24h/media/mob-acc_hero_image.c0e1df54.jpg";